import React, { useState, useEffect, Fragment } from 'react'
import { observer } from 'mobx-react'
import queryString from 'query-string'
import { Icon } from 'semantic-ui-react'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import useStores from '@stores/useStores'
import Layout from '@ui/Layouts/Survey'
import BannerCrosschq from '@ui/Banner'
import Footer from '@ui/Footer'
import Loader from '@ui/Loader'
import Divider from '@ui/Divider'
import SurveyMain from '@ui/Survey'
import ProgressBar from './Progress'
import './styles.scss'

const Survey = () => {
  const { surveyState } = useStores()
  const [loading, setLoading] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    const fetchData = async () => {
      const { brand_color, brand_logo } = queryString.parse(location.search) || {}

      if (!brand_color && !brand_logo) {
        await surveyState.getCustomization()
      } else {
        surveyState.setCustomization({ brand_color, brand_logo })
      }

      setLoading(false)
    }

    fetchData()
  }, [surveyState])

  const {
    progress,
    currentStepIndex,
    steps,
    isFirstStep,
    hasBrandColor,
    showBanner
  } = surveyState

  if (loading) return <Loader />
  return (
    <Layout className='survey-container'>
      <Layout.TopNav className={cn({ 'first-step': isFirstStep })}>
        <ProgressBar
          currentStepIndex={currentStepIndex}
          stepsLength={steps.length}
          progress={progress}
        />
      </Layout.TopNav>
      <Layout.BottomNav>
        <div
          className={`flex align-top no-wrap start support-text ${
            hasBrandColor ? 'gray' : 'blue'
          }`}
        >
          <Icon
            className={hasBrandColor ? 'light-gray' : 'blue'}
            name='info circle'
          />
          <span>{t('If you need help, email support@crosschq.com')}</span>
        </div>
        {showBanner && (
          <Fragment>
            <Divider hidden className='x12' />
            <BannerCrosschq survey />
          </Fragment>
        )}
        <Divider soft className='x24' />
        <Footer showCrosschqLogo={surveyState.hasBrandLogo} />
      </Layout.BottomNav>
      <Layout.Main>
        <SurveyMain showLanguageSelector />
      </Layout.Main>
    </Layout>
  )
}

export default observer(Survey)
